import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {useLocation, withRouter} from "react-router-dom";

import GroheExitButton from "./groheExitButton";
import GroheMenuButton from "./groheMenuButton";
// import GroheCartBox from "./groheCartBox"; // removed for now, we have another button
import GroheShareParentButton from "./groheShareParentButton";
import {setLookOpened, setLookPageOpened} from "../../../../actions/lookFunctions";
import {setCanvasScale} from "../../../../actions/actionFunctions";
import GroheSaveButton from "./groheSaveButton";
import {zoomCanvasOut} from "../../lookNavigation/lookFunctions";
import {ROUTES} from "../../../../routes";
import GrohePingPilotButton from "./grohePingPilotButton";
import GroheShopButton from "./groheShopButton";

const GroheTopButtons = (props) => {

  const {lookOpened, setLookOpened, setLookPageOpened, setCanvasScale, imageCanvas, history, isSolidSurface} = props;
  let location = useLocation();

  const topButtonClick = (setHomeRoute = true) => {
    if (lookOpened) {
      setLookOpened(null);
      setLookPageOpened("");
      zoomCanvasOut(imageCanvas, setCanvasScale);
    }
    if (location && location.pathname && (location.pathname !== ROUTES.home)) {
      setLookPageOpened("");
      if (setHomeRoute) {
        history.push(ROUTES.home);
      }
    }
  }

  return (
    <Fragment>
      <div className="gm-buttons">
        {isSolidSurface ? null : (
          <Fragment>
            <GroheShopButton topButtonClick={topButtonClick}/>
            <GroheExitButton/>
            <GroheMenuButton topButtonClick={topButtonClick}/>
          </Fragment>
        )}
        <GroheShareParentButton topButtonClick={topButtonClick}/>
        <GroheSaveButton topButtonClick={topButtonClick}/>
        <GrohePingPilotButton topButtonClick={topButtonClick}/>
      </div>
      {/*<GroheCartBox topButtonClick={topButtonClick}/>*/}
    </Fragment>
  )
};

GroheTopButtons.propTypes = {
  imageCanvas: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ])
}

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  const {isSolidSurface} = store.fabricatorState;
  return {
    lookOpened,
    isSolidSurface,
  };
};

const mapDispatchToProps = {
  setLookOpened,
  setLookPageOpened,
  setCanvasScale,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheTopButtons)
)
